import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import {
  $createParagraphNode,
  $createTextNode,
  $getRoot,
  $insertNodes,
} from "lexical";
import { $generateHtmlFromNodes, $generateNodesFromDOM } from "@lexical/html";
import { useEffect, useRef } from "react";
import dayjs from "dayjs";
import { Tooltip } from "react-tooltip";

export function UpdateActiveWorkbaordPlugin({
  setAssignmentCounts,
  assignmentsCount,
  showAssingment,
  setShowAssingment,
  selectedAssignment,
  setSelectedAssignment,
  onChangeAssignmentData,
  setOnChangeAssignmentData,
  setAssignmentCountsTwo,
  assignmentsCountTwo,
  showDropdownRubric,
  setShowDropdownRubric,
  rubricCount,
  setRubricCount,
  rubricCounttTwo,
  setRubricCountTwo,
  onChangeRubricData,
  setOnChangeRubricData,
  selectedRubric,
  setSelectedRubric,
  setPreviesAssignment,
  setPreviesRubric,
  setFormAssignmentState,
  updateFuntion,
  setUpdateFuntion,
  isRubricConfirmModalData,
  afterConfirmation,
  isAssingmentConfirmModalData,
  callAddAssignmentFun,
  setCallAddAssignmentFun,
  callSwitchToRubricFun,
  setCallSwitchToRubricFun,
  pendingAssignmentClickArgs,
  setPendingAssignmentClickArgs,
  setActiveWorkboard,
  syncEditorActiveWorkboardName,
  workboards,
  defaultWorkboardData,
  updateWorkboardDataByName,
  lesson,
  setFormState,
  setIsAssignment,
  setIsRubric,
  setPopupVisible,
  lessonbuttonStyle,
  globleOnChange,
  setGlobleOnChange,
  updateGlobleOnChangeData,
  globleSaveData,
  assignmentDurationCount,
  assignmentDurationChangeTime,
  setAssignmentDuration,
  setAssignmentDurationCount,
  checkAssignmentopen,
  setEachAssignment_id,
  setassignment_id,
  formAssignmentState,
  setShowRubricPopUp,
  setswitchschoologySync,
  setEachRubric_id,
  setrubric_id,
  Assignmentgeneration,
  getassignmentdetails,
  clickSaveBTN,
  setClickSaveBTN,
  clickSaveRubricBTN,
  setClickSaveRubricBTN,
  setGlobleOnChangeDataSave,
  setFormErrorAssignmentState,
  updateDefaultWorkboardData,
  setActiveTab,
  setShowDropdown,
  activeWorkboard,
  isAssignment,
  isRequired,
  reFormatterLoading,
  generateAllMode,
  sendGenerateLession,
  formState,
  typeChanged,
  setTypeChanged,
  setGetSpecificAssignmentType
}) {
  const [editor] = useLexicalComposerContext();

  function update(
    workboard,
    workboardName,
    previesAssignment,
    removeWorkboardAssignment,
  ) {


    syncEditorActiveWorkboardName?.(workboardName);
    if (
      previesAssignment === "previesAssignment" ||
      previesAssignment === "previesRubric"
    ) {
      setActiveWorkboard({
        name: workboardName,
        data: workboard,
      });
    } else {
      setActiveWorkboard(workboard);
    }
    if (workboardName === workboards.ASSIGNMENT.name) {
      // setPopupVisible(true);
      setIsAssignment(true);

      setIsRubric(false);
    } else if (workboardName === workboards.RUBRIC.name) {
      setPopupVisible(false);
      setIsAssignment(false);
      setIsRubric(true);
      // setFormState((prev) => ({
      //   ...prev,
      //   chat_query: "Create Rubric" + " " + (rubricCount.length + 1),
      // }));
    } else if (workboardName === workboards.LESSON.name) {
      setPopupVisible(false);
      setIsAssignment(false);
      setIsRubric(false);
      setFormState((prev) => ({
        ...prev,
        chat_query: "",
      }));
    }
    editor.update(() => {
      const root = $getRoot();
      // Clear the root node
      root.clear();

      // Get the active workboard data
      if (
        previesAssignment === "previesAssignment" ||
        previesAssignment === "previesRubric"
      ) {
        var activeWorkboardData = workboard;
      } else {
        var activeWorkboardData = workboard.data;
      }

      if (workboardName === "Assignment") {
        if (
          previesAssignment !== "previesAssignment" &&
          removeWorkboardAssignment !== "removeWorkboardAssignment"
        ) {
          if (activeWorkboardData.length > 2) {
            const getassignmentdetailsCondition =
              getassignmentdetails[assignmentsCountTwo] !== undefined;

            if (getassignmentdetailsCondition) {
              if (
                formAssignmentState.name !== "" &&
                formAssignmentState.name !== null &&
                getassignmentdetails[assignmentsCountTwo].name !== "" &&
                getassignmentdetails[assignmentsCountTwo].name !== null &&
                formAssignmentState.type !== null &&
                getassignmentdetails[assignmentsCountTwo].type !== null &&
                formAssignmentState.duration_minutes !== 0 &&
                formAssignmentState.duration_minutes !== null &&
                getassignmentdetails[assignmentsCountTwo].duration_minutes !==
                0 &&
                getassignmentdetails[assignmentsCountTwo].duration_minutes !==
                null
              ) {
                setOnChangeAssignmentData((prev) => {
                  const newState = [...prev]; // Create a copy of the previous state array
                  newState[assignmentsCountTwo] = workboards.ASSIGNMENT.data;
                  return newState; // Return the new state
                });
              }
            } else {
              if (
                formAssignmentState.name !== "" &&
                formAssignmentState.name !== null &&
                formAssignmentState.type !== null &&
                formAssignmentState.duration_minutes !== 0 &&
                formAssignmentState.duration_minutes !== null
              ) {
                setOnChangeAssignmentData((prev) => {
                  const newState = [...prev]; // Create a copy of the previous state array
                  newState[assignmentsCountTwo] = workboards.ASSIGNMENT.data;
                  return newState; // Return the new state
                });
              }
            }
          }
        }

        if (removeWorkboardAssignment === "removeWorkboardAssignment") {
          activeWorkboardData = "";
        }
      }

      if (workboardName === "Rubric") {
        if (
          previesAssignment !== "previesRubric" &&
          removeWorkboardAssignment !== "removeWorkboardRubric"
        ) {
          if (activeWorkboardData.length > 2) {
            setOnChangeRubricData((prev) => {
              const newState = [...prev]; // Create a copy of the previous state array
              newState[rubricCounttTwo] = workboards.RUBRIC?.data; // Update the specific index
              return newState; // Return the new state
            });
          }
        }

        if (removeWorkboardAssignment === "removeWorkboardRubric") {
          activeWorkboardData = "";
        }
      }

      // Parse the HTML string into a DOM
      const parser = new DOMParser();
      const dom = parser.parseFromString(activeWorkboardData, "text/html");

      // Generate nodes from the DOM
      const nodes = $generateNodesFromDOM(editor, dom);

      // Insert the nodes into the root node
      try {
        $insertNodes(nodes);
      } catch (error) {
        console.error(error);
        const root = $getRoot();
        const p = $createParagraphNode();
        p.append($createTextNode(activeWorkboardData));
        // root.append(nodes);
        root.append(p);
      }

      // Select the root node
      root.select();
    });
  }
  const EMPTY_LESSON_PLACEHOLDER_DESCRIPTION = '@$%^231#^#a5fgd%532^&4R3&';

  if (updateFuntion) {
    if (
      afterConfirmation === "addRubric" ||
      afterConfirmation === "LessonToAddRubric"
    ) {
      update("", "Rubric", "previesAssignment", "removeWorkboardRubric");
    } else if (
      afterConfirmation === "Rubric" ||
      afterConfirmation === "LessonToRubric"
    ) {
      update(
        onChangeRubricData[isRubricConfirmModalData.selectedRubricIndex],
        "Rubric",
        "previesRubric",
      );
    } else if (
      afterConfirmation === "Assignment" ||
      afterConfirmation === "LessonToAssignment"
    ) {
      update(
        onChangeAssignmentData[
        isAssingmentConfirmModalData.selectedAssingmentIndex
        ],
        "Assignment",
        "previesAssignment",
      );
    } else if (
      afterConfirmation === "addAssingment" ||
      afterConfirmation === "LessonToAddAssignment"
    ) {
      update(
        "",
        "Assignment",
        "previesAssignment",
        "removeWorkboardAssignment",
      );
    } else if (afterConfirmation === "Lesson") {
      update(
        lesson?.description,
        "Lesson",
        "previesAssignment",
        "removeWorkboardAssignment",
      );
    }

    setUpdateFuntion(false);
  }

  if (clickSaveBTN) {
    const workboardItem = Object.values(workboards).find(
      (item) => item.name === "Assignment",
    );
    update(workboardItem, "Assignment");
    setClickSaveBTN(false);
  }

  if (clickSaveRubricBTN) {
    const workboardItem = Object.values(workboards).find(
      (item) => item.name === "Rubric",
    );

    update(workboardItem, "Rubric");
    setClickSaveRubricBTN(false);
  }

  const assignmentDropdownRef = useRef(null);
  const rubricDropdownRef = useRef(null);

  /**
   * `handleAddAssignment`/`handleAddRubric` both take a `generateAllMode`
   * parameter that shadows the prop of the same name, so inside them the prop
   * is unreachable. Alias it here for the checks that must read the actual run
   * state rather than the caller's argument.
   */
  const isGenerateAllRun = generateAllMode;

  const handleAddAssignment = (generateAllMode = false) => {
    setGlobleOnChangeDataSave(false);
    if (assignmentsCount.length - 1 === assignmentsCountTwo) {
      const globleOnChange = JSON.parse(
        sessionStorage.getItem("globleOnChangeData"),
      );

      const globleSaveDataUpdate = globleOnChange.ASSIGNMENT.data;

      globleSaveDataUpdate.push(workboards.ASSIGNMENT.data);

      globleOnChange.ASSIGNMENT.data = globleSaveDataUpdate;

      setGlobleOnChange(globleOnChange);

      sessionStorage.setItem(
        "globleOnChangeData",
        JSON.stringify(globleOnChange),
      );
    }

    updateDefaultWorkboardData(defaultWorkboardData.ASSIGNMENT.name, "");

    const newAssignment = `Assignment ${assignmentsCount.length + 1}`;


    setAssignmentCounts([...assignmentsCount, newAssignment]);
    setAssignmentCountsTwo(assignmentsCount.length);
    setShowAssingment(false);
    setSelectedAssignment(newAssignment);
    // Generate All parks the teacher on the workboard tab for the whole run;
    // hopping to the lesson tab per step would undo that mid-generation.
    if (!isGenerateAllRun) setActiveTab("lesson");
    setPreviesAssignment(false);
    setIsAssignment(true);

    setPopupVisible(true);

    if (generateAllMode) {
      // Generate All: keep the "add assignment" flow, but prefill defaults
      // instead of clearing them back to null.
      setFormAssignmentState((prevState) => ({
        ...prevState,
        name: `${formState?.name ?? ""} Assignment`,
        duration_minutes: 5,
        type: 7,
      }));

      // Sync visible timer UI (assignmentDuration.minutes) to 5.
      assignmentDurationChangeTime(-999);
      assignmentDurationChangeTime(5);
      sessionStorage.setItem("assignmentDurationCount", 1);
    } else {
      if (!checkAssignmentopen) {
        setFormState((prev) => ({
          ...prev,
          chat_query: "Create Assignment" + " " + (assignmentsCount.length + 1),
        }));
      }

      setFormAssignmentState((prevState) => ({
        ...prevState,
        name: "",
        duration_minutes: null,
        start_date: dayjs().format("YYYY-MM-DD"),
        type: null,
      }));

      const sumOfCount = 5 * assignmentDurationCount;
      assignmentDurationChangeTime(-sumOfCount);
      sessionStorage.setItem("assignmentDurationCount", 0);
    }
  };

  if (callAddAssignmentFun) {
    handleAddAssignment();
    const workboardItem = Object.values(workboards).find(
      (item) => item.name === workboards.ASSIGNMENT.name,
    );
    if (workboardItem) {
      update(
        workboardItem,
        workboards.ASSIGNMENT.name,
        "no_previesAssignment",
        "removeWorkboardAssignment",
      );
      queueMicrotask(() => {
        sendGenerateLession?.({ preventDefault() { } }, true);
      });
    }
    setCallAddAssignmentFun(false);
  }


  const toggleAssingmentDropdown = () => {
    setShowAssingment((prev) => !prev);
    setShowDropdownRubric(false);
  };

  const handleAddRubric = (generateAllMode = false) => {
    if (rubricCounttTwo.length - 1 === rubricCounttTwo) {
      const globleInputData = {
        data: workboards.RUBRIC.data,
        Id: null,
      };
      updateGlobleOnChangeData(globleOnChange.RUBRIC.name, globleInputData);
    }

    updateDefaultWorkboardData(defaultWorkboardData.RUBRIC.name, "");

    const newRubric = `Rubric ${rubricCount.length + 1}`;
    setRubricCount([...rubricCount, newRubric]);
    setRubricCountTwo(rubricCount.length);
    setShowDropdownRubric(false);
    setSelectedRubric(newRubric);
    setPreviesRubric(false);
    setActiveWorkboard(workboards.RUBRIC);
    // Same as the assignment step — see the note in handleAddAssignment.
    if (!isGenerateAllRun) setActiveTab("lesson");

    setPopupVisible(false);
    setIsAssignment(false);

    if (!generateAllMode) {
      setFormState((prev) => ({
        ...prev,
        chat_query: `Create Rubric ${rubricCount.length + 1}`,
      }));
    }
  };

  const toggleDropdownRubric = () => {
    setShowAssingment(false);
    if (Object.entries(lesson).length !== 0) {
      setShowDropdownRubric(!showDropdownRubric);
    }
  };

  //bb
  const handleAssignmentClick = (assignment, index) => {
    let globleOnChangeData = {};
    try {
      globleOnChangeData = JSON.parse(
        sessionStorage.getItem("globleOnChangeData") || "{}",
      );
    } catch {
      globleOnChangeData = {};
    }

    const applyAssignmentFormFromRow = (row) => {
      if (!row || typeof row !== "object") return;
      const rawDm = Number(row.duration_minutes);
      const safeDm = Number.isFinite(rawDm)
        ? Math.max(0, Math.min(180, rawDm))
        : 0;
      const countStep = safeDm > 0 ? Math.round(safeDm / 5) : 0;

      setAssignmentDuration({ minutes: safeDm });
      setAssignmentDurationCount(countStep);
      sessionStorage.setItem("assignmentDurationCount", String(countStep));

      setFormAssignmentState((prevState) => ({
        ...prevState,
        name: row.name ?? "",
        duration_minutes: row.duration_minutes ?? safeDm,
        start_date:
          row.start_date && String(row.start_date).trim() !== ""
            ? row.start_date
            : dayjs().format("YYYY-MM-DD"),
        type: row.type ?? null,
        end_date: row.end_date ?? null,
      }));
    };

    if (assignmentsCount.length === Number(assignmentsCountTwo) + 1) {
      if (globleOnChange.ASSIGNMENT.formAssignment === undefined) {
        const globleInputData = {
          data: workboards.ASSIGNMENT.data,
          Id: null,
        };

        updateGlobleOnChangeData(
          globleOnChange.ASSIGNMENT.name,
          globleInputData,
          "formAssignmentState_true",
          formAssignmentState,
        );
      }
    }
    setswitchschoologySync(
      getassignmentdetails[index] !== undefined
        ? getassignmentdetails[index]?.synced_with_schoology
        : false,
    );
    setSelectedAssignment(assignment);
    setAssignmentCountsTwo(index);
    setShowDropdown(false);
    setShowAssingment(false);
    if (
      globleSaveData.ASSIGNMENT.data[index] !== undefined &&
      globleSaveData.ASSIGNMENT.data[index] !== null
    ) {
      if (globleSaveData.ASSIGNMENT.data[index].Id) {
        let GlobleSaveData = {};
        try {
          GlobleSaveData = JSON.parse(
            sessionStorage.getItem("GlobleSaveData") || "{}",
          );
        } catch {
          GlobleSaveData = {};
        }

        setPreviesAssignment(true);
        setEachAssignment_id(GlobleSaveData.ASSIGNMENT.data[index].Id);
        setassignment_id(GlobleSaveData.ASSIGNMENT.data[index].Id);
        if (!generateAllMode) {
          setPopupVisible(false);
          if (!checkAssignmentopen) {
            setFormState((prev) => ({
              ...prev,
              chat_query: "",
            }));
          }
        }

        applyAssignmentFormFromRow(
          GlobleSaveData.ASSIGNMENT.formSaveAssignment?.[index] ||
          globleOnChangeData.ASSIGNMENT?.formAssignment?.[index],
        );
      } else {
        setEachAssignment_id(null);
      }
    } else {
      const draftRow = globleOnChangeData.ASSIGNMENT?.formAssignment?.[index];
      if (draftRow !== undefined && draftRow !== null) {
        setPreviesAssignment(false);
        setEachAssignment_id(null);

        if (!generateAllMode) {
          setPopupVisible(true);
          if (!checkAssignmentopen) {
            setFormState((prev) => ({
              ...prev,
              chat_query: "Create Assignment" + " " + (Number(index) + 1),
            }));
          }
        }

        applyAssignmentFormFromRow(draftRow);
      } else {
        setIsAssignment(true);

        if (!generateAllMode) {
          setPopupVisible(true);
          if (!checkAssignmentopen) {
            setFormState((prev) => ({
              ...prev,
              chat_query: "Create Assignment" + " " + (Number(index) + 1),
            }));
          }
        }

        setFormAssignmentState((prevState) => ({
          ...prevState,
          name: "",
          duration_minutes: null,
          start_date: dayjs().format("YYYY-MM-DD"),
          type: null,
        }));

        setAssignmentDuration({ minutes: 0 });
        setAssignmentDurationCount(0);
        sessionStorage.setItem("assignmentDurationCount", "0");
      }
    }

    const assignmentDataRow = globleOnChangeData?.ASSIGNMENT?.data?.[index];
    if (assignmentDataRow?.data !== undefined) {
      update(
        assignmentDataRow.data,
        "Assignment",
        "previesAssignment",
      );
      updateWorkboardDataByName(
        "Assignment",
        assignmentDataRow.data
      );
    } else if (assignmentDataRow !== undefined) {
      update(
        assignmentDataRow,
        "Assignment",
        "previesAssignment",
      );
      updateWorkboardDataByName(
        "Assignment",
        assignmentDataRow
      );
    }
    setActiveWorkboard(workboards.ASSIGNMENT);

    setIsAssignment(true);
  };

  if (pendingAssignmentClickArgs) {
    const { assignment, index } = pendingAssignmentClickArgs;
    handleAssignmentClick(assignment, index);
    setPendingAssignmentClickArgs(null);
  }

  const handleRubricClick = (rubric, index) => {
    const globleOnChangeData = JSON.parse(
      sessionStorage.getItem("globleOnChangeData"),
    );

    if (rubricCounttTwo.length === Number(rubricCounttTwo) + 1) {
      if (globleOnChange.RUBRIC.formAssignment[rubricCounttTwo] === undefined) {
        const globleInputData = {
          data: workboards.RUBRIC.data,
          Id: null,
        };

        updateGlobleOnChangeData(globleOnChange.RUBRIC.name, globleInputData);
      }
    }

    setSelectedRubric(rubric);
    setRubricCountTwo(index);
    setShowDropdownRubric(false);

    let rubricIdsFromStorage = [];
    try {
      const raw = sessionStorage.getItem("Rubric_id");
      const parsed = raw ? JSON.parse(raw) : [];
      rubricIdsFromStorage = Array.isArray(parsed) ? parsed : [];
    } catch {
      rubricIdsFromStorage = [];
    }

    const rubricIdAtIndex = rubricIdsFromStorage[index];
    const rubricIdFromGloble =
      globleSaveData.RUBRIC.data[index]?.Id ?? null;
    const resolvedRubricId =
      rubricIdAtIndex != null && rubricIdAtIndex !== ""
        ? rubricIdAtIndex
        : rubricIdFromGloble;

    if (
      globleSaveData.RUBRIC.data[index] !== undefined &&
      globleSaveData.RUBRIC.data[index] !== null
    ) {
      if (resolvedRubricId != null && resolvedRubricId !== "") {
        setPreviesRubric(true);
        setEachRubric_id(resolvedRubricId);

        setFormState((prev) => ({
          ...prev,
          chat_query: "",
        }));

        setrubric_id(resolvedRubricId);
      } else {
        setEachRubric_id(null);
      }
    } else {
      setPreviesRubric(false);
      setEachRubric_id(null);
    }


    if (globleOnChangeData.RUBRIC.data[index].data !== undefined) {
      update(
        globleOnChangeData.RUBRIC.data[index].data,
        "Rubric",
        "previesRubric",
      );
      updateWorkboardDataByName(
        "Rubric",
        globleOnChangeData.RUBRIC.data[index].data,
      );
    } else {
      update(globleOnChangeData.RUBRIC.data[index], "Rubric", "previesRubric");
      updateWorkboardDataByName(
        "Rubric",
        globleOnChangeData.RUBRIC.data[index],
      );
    }
    setActiveWorkboard(workboards.RUBRIC);

    setPopupVisible(false);
    setIsAssignment(false);
  };

  if (callSwitchToRubricFun) {
    setEachRubric_id(null);
    setrubric_id("");
    handleAddRubric(true);
    const rubricWorkboardItem = Object.values(workboards).find(
      (item) => item.name === workboards.RUBRIC.name,
    );
    if (rubricWorkboardItem) {
      update(
        rubricWorkboardItem,
        workboards.RUBRIC.name,
        "no_previesAssignment",
        "removeWorkboardRubric",
      );

      queueMicrotask(() => {
        sendGenerateLession?.({ preventDefault() { } }, true);
      });
    }
    setCallSwitchToRubricFun(false);
  }


  const handleTypeChangedCancel = () => {
    setTypeChanged(false);
    setGetSpecificAssignmentType(null)
  };

  const handleTypeChangedManual = () => {
    setTypeChanged(false);
    setIsAssignment(false)
    setIsRubric(true)
    setActiveWorkboard(workboards.RUBRIC)

    setGetSpecificAssignmentType(null)

    handleRubricClick(`Rubric ${assignmentsCountTwo + 1}`, assignmentsCountTwo);
    // handleRubricClick(`Rubric ${1 + 1}`, 1);
  };

  const handleTypeChangedGenerateAI = () => {
    handleTypeChangedManual()

    queueMicrotask(() => {
      sendGenerateLession?.({ preventDefault() { } }, false, true);
    });
  };



  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showAssingment &&
        assignmentDropdownRef.current &&
        !assignmentDropdownRef.current.contains(event.target)
      ) {
        setShowAssingment(false); // close popup
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showAssingment]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showDropdownRubric &&
        rubricDropdownRef.current &&
        !rubricDropdownRef.current.contains(event.target)
      ) {
        setShowDropdownRubric(false); // close popup
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDropdownRubric]);

  return (
    <div className="edit-active-lesson-btn-container">
      {Object.values(workboards).map((workboard, index) => {
        return (
          <>
            {workboard.name === workboards.LESSON.name ? (
              <div
                className="tab-dropdown"
                data-tooltip-id="tab-dropdown-lesson"
              >
                <button
                  key={index} // It's important to provide a unique key for list items in React
                  type="button"
                  style={{
                    ...lessonbuttonStyle,
                    // ...(localStorage.getItem("skipLesson") === "true" || skipLesson
                    //   ? {
                    //     cursor: "not-allowed",  // Disable pointer interaction
                    //     opacity: 0.5,              // Make the button semi-transparent
                    //     color: "black",          // Set the text color to black
                    //   }
                    //   : {}),

                    ...((Assignmentgeneration || reFormatterLoading || generateAllMode)
                      ? {
                        cursor: "not-allowed", // Disable pointer interaction
                        opacity: 0.5, // Make the button semi-transparent
                        color: "black", // Set the text color to black
                      }
                      : {
                        cursor: "pointer", // Disable pointer interaction
                        opacity: 1, // Make the button semi-transparent
                      }),
                  }}
                  className={`dropbtn ${activeWorkboard.name === workboard.name ? "active" : ""
                    } ${defaultWorkboardData.LESSON?.data !==
                      workboards.LESSON?.data
                      ? ""
                      : "completed"
                    }`}
                  // disabled={
                  //   // typeof lesson_id === "undefined" ||
                  //   // lesson_id === null ||
                  //   // lesson_id === ""
                  //   localStorage.getItem("skipLesson") === "true" ||
                  //   skipLesson
                  // }

                  disabled={Assignmentgeneration || generateAllMode}
                  onClick={() => {
                    setShowDropdownRubric(false);
                    setShowAssingment(false);
                    update(
                      Object.values(workboards).find(
                        (item) => item.name === "Lesson",
                      ),
                      workboard?.name,
                    );
                  }}
                >
                  {" "}
                  {workboard?.name}
                </button>
                <Tooltip
                  id="tab-dropdown-lesson"
                  place="top"
                  content={
                    Assignmentgeneration &&
                    "Skipped lesson cant be created later"
                  }
                  type="light"
                  effect="float"
                  style={{
                    opacity: 1.5, // Set opacity of the tooltip to 1 (always visible)
                  }}
                />
              </div>
            ) : (
              ""
            )}

            {workboard.name === workboards.ASSIGNMENT.name ? (
              <div className="tab-dropdown">
                <button
                  className="dropbtn"
                  onClick={toggleAssingmentDropdown}
                  style={{
                    cursor:
                      generateAllMode || lesson.description === EMPTY_LESSON_PLACEHOLDER_DESCRIPTION ||
                        Object.entries(lesson).length === 0 ||
                        reFormatterLoading
                        ? "not-allowed"
                        : "pointer",
                    opacity:
                      generateAllMode || lesson.description === EMPTY_LESSON_PLACEHOLDER_DESCRIPTION ||
                        Object.entries(lesson).length === 0 ||
                        reFormatterLoading
                        ? "0.5"
                        : "1",
                    color:
                      activeWorkboard.name === "Assignment"
                        ? "#0068ff"
                        : "black",
                  }}
                  disabled={
                    generateAllMode || lesson.description === EMPTY_LESSON_PLACEHOLDER_DESCRIPTION ||
                    Object.entries(lesson).length === 0 ||
                    reFormatterLoading
                  } //bb :from here you can enable button
                >
                  {selectedAssignment}

                  <span
                    style={{
                      transform: showAssingment
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    }}
                  >
                    <i className="fa-solid fa-angle-down"></i>
                  </span>
                </button>

                {showAssingment && (
                  <div className="dropdown-content" ref={assignmentDropdownRef}>
                    {assignmentsCount.map((assignment, index) => (
                      <div
                        key={index}
                        className="assignment-item"
                        onClick={() => {
                          let globleOnChange = {};
                          try {
                            globleOnChange = JSON.parse(
                              sessionStorage.getItem("globleOnChangeData") ||
                              "{}",
                            );
                          } catch {
                            globleOnChange = {};
                          }
                          const globleOnChangeData = globleOnChange;
                          const newFormAssignmentArrya = {
                            name: formAssignmentState.name,
                            assignment: null,
                            assignment_json: null,
                            lesson: null,
                            duration_minutes:
                              formAssignmentState.duration_minutes,
                            start_date: formAssignmentState.start_date,
                            end_date: formAssignmentState.end_date,
                            type: formAssignmentState.type,
                          };
                          if (
                            activeWorkboard.name === "Assignment" &&
                            (globleOnChangeData.ASSIGNMENT?.data?.length ?? 0) >
                            (globleOnChangeData.ASSIGNMENT?.formAssignment
                              ?.length ?? 0)
                          ) {
                            const formArr = [
                              ...(globleOnChange.ASSIGNMENT?.formAssignment ||
                                []),
                            ];
                            if (
                              globleOnChangeData.ASSIGNMENT.formAssignment?.[
                              assignmentsCountTwo
                              ] === undefined
                            ) {
                              formArr.push(newFormAssignmentArrya);
                            } else {
                              formArr[assignmentsCountTwo] =
                                newFormAssignmentArrya;
                            }
                            globleOnChange.ASSIGNMENT =
                              globleOnChange.ASSIGNMENT || {};
                            globleOnChange.ASSIGNMENT.formAssignment = formArr;
                            setGlobleOnChange(globleOnChange);
                            sessionStorage.setItem(
                              "globleOnChangeData",
                              JSON.stringify(globleOnChange),
                            );
                          } else {
                            const formArr = [
                              ...(globleOnChange.ASSIGNMENT?.formAssignment ||
                                []),
                            ];
                            formArr[assignmentsCountTwo] = newFormAssignmentArrya;
                            globleOnChange.ASSIGNMENT =
                              globleOnChange.ASSIGNMENT || {};
                            globleOnChange.ASSIGNMENT.formAssignment = formArr;
                            setGlobleOnChange(globleOnChange);
                            sessionStorage.setItem(
                              "globleOnChangeData",
                              JSON.stringify(globleOnChange),
                            );
                          }
                          handleAssignmentClick(assignment, index);
                        }}
                      >
                        {assignment}
                      </div>
                    ))}

                    {!generateAllMode && (
                      <div
                        id="add-assignment"
                        onClick={() => {
                          setEachAssignment_id(null);
                          setassignment_id("");
                          if (!checkAssignmentopen) {
                            if (isAssignment) {
                              setswitchschoologySync(false);
                              let errors = {};
                              if (isRequired(formAssignmentState?.name)) {
                                errors.name = "Name is required";
                              }
                              if (
                                isRequired(
                                  formAssignmentState?.duration_minutes,
                                )
                              ) {
                                errors.duration_minutes = "Timer is required";
                              }
                              if (isRequired(formAssignmentState?.start_date)) {
                                errors.start_date = "Start date is required";
                              }
                              if (isRequired(formAssignmentState?.type)) {
                                errors.type = "Type is required";
                              }
                              setFormErrorAssignmentState(errors);

                              if (
                                Object.values(errors).some((error) => error)
                              ) {
                                return;
                              }
                            }
                          }
                          let getdata = {};
                          try {
                            getdata = JSON.parse(
                              sessionStorage.getItem("GlobleSaveData") || "{}",
                            );
                          } catch {
                            getdata = {};
                          }
                          const assignmentLen =
                            getdata.ASSIGNMENT?.data?.length ?? 0;
                          const rubricLen = getdata.RUBRIC?.data?.length ?? 0;

                          if (rubricCount.length === 0) {
                            if (assignmentLen > rubricLen) {
                              setShowRubricPopUp(true);
                            }
                          } else if (assignmentLen > rubricLen) {
                            setShowRubricPopUp(true);
                          }

                          let globleOnChangeData = {};
                          try {
                            globleOnChangeData = JSON.parse(
                              sessionStorage.getItem("globleOnChangeData") ||
                              "{}",
                            );
                          } catch {
                            globleOnChangeData = {};
                          }

                          const newFormAssignmentArrya = {
                            name: formAssignmentState.name,
                            assignment: null,
                            assignment_json: null,
                            lesson: null,
                            duration_minutes:
                              formAssignmentState.duration_minutes,
                            start_date: formAssignmentState.start_date,
                            end_date: formAssignmentState.end_date,
                            type: formAssignmentState.type,
                          };

                          if (
                            activeWorkboard.name === "Assignment" &&
                            (globleOnChangeData.ASSIGNMENT?.data?.length ?? 0) >
                            (globleOnChangeData.ASSIGNMENT?.formAssignment
                              ?.length ?? 0)
                          ) {
                            const next = { ...globleOnChangeData };
                            const formArr = [
                              ...(next.ASSIGNMENT?.formAssignment || []),
                            ];
                            if (
                              next.ASSIGNMENT?.formAssignment?.[
                              assignmentsCountTwo
                              ] === undefined
                            ) {
                              formArr.push(newFormAssignmentArrya);
                            } else {
                              formArr[assignmentsCountTwo] =
                                newFormAssignmentArrya;
                            }
                            next.ASSIGNMENT = next.ASSIGNMENT || {};
                            next.ASSIGNMENT.formAssignment = formArr;
                            setGlobleOnChange(next);
                            sessionStorage.setItem(
                              "globleOnChangeData",
                              JSON.stringify(next),
                            );
                          } else {
                            const next = { ...globleOnChangeData };
                            const formArr = [
                              ...(next.ASSIGNMENT?.formAssignment || []),
                            ];
                            formArr[assignmentsCountTwo] = newFormAssignmentArrya;
                            next.ASSIGNMENT = next.ASSIGNMENT || {};
                            next.ASSIGNMENT.formAssignment = formArr;
                            setGlobleOnChange(next);
                            sessionStorage.setItem(
                              "globleOnChangeData",
                              JSON.stringify(next),
                            );
                          }

                          handleAddAssignment();

                          const workboardItem = Object.values(workboards).find(
                            (item) => item.name === workboard.name,
                          );
                          update(
                            workboardItem,
                            workboard.name,
                            "no_previesAssignment",
                            "removeWorkboardAssignment",
                          );
                        }}
                      >
                        + Add Assignment
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : (
              ""
            )}

            {workboard.name === workboards.RUBRIC.name ? (
              <div className="tab-dropdown">
                <button
                  className="dropbtn"
                  onClick={toggleDropdownRubric}
                  style={{
                    cursor:
                      generateAllMode || lesson.description === EMPTY_LESSON_PLACEHOLDER_DESCRIPTION ||
                        Object.entries(lesson).length === 0 ||
                        reFormatterLoading
                        ? "not-allowed"
                        : "pointer",
                    opacity:
                      generateAllMode || lesson.description === EMPTY_LESSON_PLACEHOLDER_DESCRIPTION ||
                        Object.entries(lesson).length === 0 ||
                        reFormatterLoading
                        ? "0.5"
                        : "1",
                    color:
                      activeWorkboard.name === "Rubric" ? "#0068ff" : "black",
                  }}
                  disabled={
                    generateAllMode || lesson.description === EMPTY_LESSON_PLACEHOLDER_DESCRIPTION ||
                    Object.entries(lesson).length === 0 ||
                    reFormatterLoading
                  } //bb :from here you can enable button
                >
                  {selectedRubric}
                  <span
                    style={{
                      transform: showDropdownRubric
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    }}
                  >
                    <i className="fa-solid fa-angle-down"></i>
                  </span>
                </button>

                {showDropdownRubric && (
                  <div className="dropdown-content" ref={rubricDropdownRef}>
                    {rubricCount.map((rubric, index) => (
                      <div
                        key={index}
                        className="assignment-item"
                        onClick={() => {
                          handleRubricClick(rubric, index);
                        }}
                      >
                        {/* {rubric} */}
                        {rubric.charAt(0).toUpperCase() + rubric.slice(1)}
                      </div>
                    ))}

                    {
                      !generateAllMode && (
                        <div
                          id="add-assignment"
                          onClick={() => {
                            setEachRubric_id(null);
                            setrubric_id("");
                            handleAddRubric();
                            const workboardItem = Object.values(workboards).find(
                              (item) => item.name === workboard.name
                            );
                            update(
                              workboardItem,
                              workboard.name,
                              "no_previesAssignment",
                              "removeWorkboardRubric"
                            );
                          }}
                        >
                          + Add Rubric
                        </div>
                      )}
                  </div>
                )}
              </div>
            ) : (
              ""
            )}
          </>
        );
      })}


      {typeChanged && (
        <div
          role="dialog"
          aria-modal="true"
          aria-labelledby="type-changed-title"
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 1300,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "16px",
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "12px",
              maxWidth: "575px",
              width: "100%",
              padding: "40px 32px",
              boxShadow: "0 10px 40px rgba(0, 0, 0, 0.2)",
              textAlign: "center",
            }}
          >
            <p
              id="type-changed-title"
              style={{
                fontSize: "16px",
                fontWeight: 500,
                color: "#1a1a1a",
                lineHeight: 1.5,
                margin: "0 0 28px 0",
              }}
            >
            Assignment type changed. Please update the rubric to match the new assignment type.
            </p>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "12px",
                flexWrap: "wrap",
              }}
            >
              <button
                type="button"
                onClick={handleTypeChangedCancel}
                style={{
                  padding: "10px 28px",
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#0068ff",
                  backgroundColor: "#fff",
                  border: "1.5px solid #0068ff",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>

              <button
                type="button"
                onClick={handleTypeChangedManual}
                style={{
                  padding: "10px 28px",
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#0068ff",
                  backgroundColor: "#fff",
                  border: "1.5px solid #0068ff",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
              >
                Generate Manually
              </button>

              <button
                type="button"
                onClick={handleTypeChangedGenerateAI}
                style={{
                  padding: "10px 28px",
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#fff",
                  backgroundColor: "#0068ff",
                  border: "1.5px solid #0068ff",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
              >
                Generate using AI
              </button>
            </div>
          </div>
        </div>
      )}
    </div >
  );
}
